import PropTypes from 'prop-types'

const IsVisible = ({ isVisible, children }) => isVisible && children

IsVisible.propTypes = {
	isVisible: PropTypes.bool.isRequired,
}

IsVisible.defaultPropTypes = {
	isVisible: true,
}

export default IsVisible
